import { useEffect, useRef } from 'react';
// https://github.com/facebook/react/issues/14369
export var useUnmounted = function () {
    var unmounted = useRef(false);
    useEffect(function () { return function () {
        unmounted.current = true;
    }; }, []);
    return unmounted;
};
